import { render, staticRenderFns } from "./LeccionD3.vue?vue&type=template&id=9242af2c&"
import script from "./LeccionD3.vue?vue&type=script&lang=js&"
export * from "./LeccionD3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports